/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Progress_Phase_DoneInputs */

const cs_import_progress_phase_done = /** @type {(inputs: Import_Progress_Phase_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotovo`)
};

const en_import_progress_phase_done = /** @type {(inputs: Import_Progress_Phase_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

/**
* | output |
* | --- |
* | "Done" |
*
* @param {Import_Progress_Phase_DoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_phase_done = /** @type {((inputs?: Import_Progress_Phase_DoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_Phase_DoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_phase_done(inputs)
	return cs_import_progress_phase_done(inputs)
});